export function submitAddCustomCsvCustomer()
{
    return({
        type:"SUBMIT_ADD_CUSTOM_CSV_CUSTOMER"
    })
}